import { NavLink, Outlet } from "react-router-dom";
import { Building2, KeyRound, Users, Languages, Palette, Plug, Compass, Bell, DownloadCloud, HeartPulse, Timer, Tags, ListChecks } from "lucide-react";
import { cn } from "@/lib/utils";
import { usePermissions } from "@/hooks/usePermissions";

const TABS = [
  { to: "/settings/organisation", label: "Organisation", icon: Building2 },
  { to: "/settings/appearance", label: "Appearance", icon: Palette },
  { to: "/settings/navigation", label: "Navigation", icon: Compass },
  { to: "/settings/language", label: "Language & Labels", icon: Languages },
  { to: "/settings/roles", label: "Roles & Permissions", icon: KeyRound },
  { to: "/settings/recipients", label: "Report Recipients", icon: Users },
  { to: "/settings/notifications", label: "Notifications", icon: Bell },
  { to: "/settings/time", label: "Time & Activity", icon: Timer },
  { to: "/settings/categories", label: "Task Categories", icon: Tags },
  { to: "/settings/checklists", label: "Checklists", icon: ListChecks, perm: "view_checklist_templates" },
  { to: "/settings/integrations", label: "Integrations", icon: Plug },
  { to: "/settings/data", label: "Data & Portability", icon: DownloadCloud },
  { to: "/settings/health", label: "System Health", icon: HeartPulse },
];

export default function SettingsLayout() {
  const perms = usePermissions();
  const tabs = TABS.filter((t) => !t.perm || perms.has(t.perm));
  return (
    <div>
      <div className="mb-6 flex gap-1 overflow-x-auto scrollbar-thin border-b border-border pb-px">
        {tabs.map((t) => {
          const Icon = t.icon;
          return (
            <NavLink key={t.to} to={t.to} data-testid={`settings-tab-${t.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className={({ isActive }) => cn(
                "flex shrink-0 items-center gap-2 whitespace-nowrap border-b-2 px-4 py-2.5 text-sm font-medium transition-colors",
                isActive ? "border-accent text-foreground" : "border-transparent text-muted-foreground hover:text-foreground"
              )}>
              <Icon className="h-4 w-4" /> {t.label}
            </NavLink>
          );
        })}
      </div>
      <Outlet />
    </div>
  );
}
